// Demo-company mode was removed from the product: every company is production.
// Kept as a no-op component so the layout import stays stable.
export const DemoCompanyBanner = () => null;
